<template>
  <div class="fullscreen-layout">
    <router-view />
  </div>
</template>
<script>
  export default {
    name: 'EmptyLayout',
    created() {
      this.$store.dispatch('routes/setFullScreenState', true)
    },
  }
</script>

<style lang="scss" scoped>
  .fullscreen-layout {
    height: 100vh;
  }
</style>
